export enum UserType {
  CORPORATE = 'corporate',
  PRIVATE = 'private',
}

export enum UserGroup {
  SESSIONLESS = 'sessonless',
  ANONYMOUS = 'anonymous',
  CLIENT = 'client',
  ADMIN = 'admin',
  CORPORATE = 'corporate',
}